// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgVoiceRecording24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g id="Icon/Media/Voice_Recording_24">
					<path
						id="Union"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V6C23 4.9 22.1 4 21 4ZM15.39 5.5L14.89 6.49H9.82L9.32 5.5H15.38H15.39ZM21.5 17.5C21.5 18.05 21.05 18.5 20.5 18.5H3.5C2.95 18.5 2.5 18.05 2.5 17.5V6.5C2.5 5.95 2.95 5.5 3.5 5.5H7.65L8.69 7.58C8.82 7.83 9.08 7.99 9.36 7.99H15.35C15.63 7.99 15.89 7.83 16.02 7.58L17.06 5.5H20.49C21.04 5.5 21.49 5.95 21.49 6.5V17.5H21.5ZM10.7899 12.4496H9.42993C9.18993 11.7396 8.61993 11.1996 7.89993 10.9796V9.63965H6.39993V11.0296C5.75993 11.2796 5.25993 11.7996 5.03993 12.4496H3.67993V13.9496H5.03993C5.25993 14.5996 5.75993 15.1196 6.39993 15.3696V16.7596H7.89993V15.4196C8.61993 15.1996 9.17993 14.6596 9.42993 13.9496H10.7899V12.4496ZM7.22993 14.0296C6.76993 14.0296 6.39993 13.6596 6.39993 13.1996C6.39993 12.7396 6.76993 12.3696 7.22993 12.3696C7.68993 12.3696 8.05993 12.7396 8.05993 13.1996C8.05993 13.6596 7.68993 14.0296 7.22993 14.0296ZM19.01 12.4496H20.37V13.9496H19.01C18.76 14.6596 18.2 15.1996 17.48 15.4196V16.7596H15.98V15.3696C15.34 15.1196 14.84 14.5996 14.62 13.9496H13.26V12.4496H14.62C14.84 11.7996 15.34 11.2796 15.98 11.0296V9.63965H17.48V10.9796C18.2 11.1996 18.77 11.7396 19.01 12.4496ZM15.98 13.1896C15.98 13.6496 16.35 14.0196 16.81 14.0196C17.27 14.0196 17.64 13.6496 17.64 13.1896C17.64 12.7296 17.27 12.3596 16.81 12.3596C16.35 12.3596 15.98 12.7296 15.98 13.1896Z"
					/>
				</g>
			</Svg>
		);
	}
);
SvgVoiceRecording24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgVoiceRecording24;
